import { formatDate } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Json2csvService } from 'csvtools-lib';
import { DevicesRegisterDeviceDialogComponent } from 'src/app/components/devices-components/devices-register-device-dialog/devices-register-device-dialog.component';
import { DeviceBasic } from 'src/app/models/device-models/device-basic-model/device-basic.model';
import { SearchByPipe } from 'src/app/pipes/search-by-pipe/search-by.pipe';
import { DevicesDevicesService } from 'src/app/services/devices-services/devices-devices-services/devices-devices.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { DevicesRegisterIOTDialogComponent } from '../devices-register-iot-dialog/devices-register-iot-dialog.component';

@Component({
  selector: 'app-devices-breadcrumb-card',
  templateUrl: './devices-breadcrumb-card.component.html',
  styleUrls: ['./devices-breadcrumb-card.component.scss']
})
export class DevicesBreadcrumbCardComponent implements OnInit {

  @Input() devices: DeviceBasic[];
  selectedOption;
  filterOpened: boolean;
  viewDisposition;


  constructor(private devicesService: DevicesDevicesService,
    private userStorageService: UserStorageService,
              public dialog: MatDialog) {
                this.viewDisposition = 'grid';
              }

  ngOnInit() {
    if (this.userStorageService.getFilterDevices()) {
      this.toggleBreadcrumbFilter();
    }
  }

  public toggleViewDisposition(viewDis) {
    this.viewDisposition = viewDis;
    this.devicesService.toggleDevicesDisposition(viewDis);
  }

  public openRegisterDeviceDialog() {
    const dialogref = this.dialog.open(DevicesRegisterDeviceDialogComponent);
    dialogref.afterClosed().subscribe(
      (result) => {
        this.selectedOption = result;
      }
    );
  }

  public openRegisterIOTDialog() {
    const dialogref = this.dialog.open(DevicesRegisterIOTDialogComponent);
    dialogref.afterClosed().subscribe(
      (result) => {
        this.selectedOption = result;
      }
    );
  }

  public toggleBreadcrumbFilter() {
    this.filterOpened = !this.filterOpened;
  }

  public search(event) {
    this.devicesService.searchDevices(event.target.value);
  }

  public exportDevicesList() {
    this.devicesService.exportDevices();
  }

}

